var map = {
	"./afghanistan.svg": [
		64374,
		[]
	],
	"./bangladesh.svg": [
		22459,
		[]
	],
	"./belgium.svg": [
		39011,
		[]
	],
	"./blank.svg": [
		75942,
		[
			5942
		]
	],
	"./bosnia-and-herzegovina.svg": [
		13395,
		[]
	],
	"./brazil.svg": [
		72274,
		[]
	],
	"./bulgaria.svg": [
		34563,
		[]
	],
	"./burmese.svg": [
		89681,
		[]
	],
	"./cambodia.svg": [
		50098,
		[]
	],
	"./china.svg": [
		44029,
		[]
	],
	"./croatia.svg": [
		55735,
		[]
	],
	"./czech-republic.svg": [
		35246,
		[]
	],
	"./denmark.svg": [
		91770,
		[]
	],
	"./estonia.svg": [
		39125,
		[]
	],
	"./ethiopia.svg": [
		46445,
		[]
	],
	"./finland.svg": [
		25824,
		[]
	],
	"./france.svg": [
		76589,
		[]
	],
	"./germany.svg": [
		39879,
		[]
	],
	"./hungary.svg": [
		79666,
		[]
	],
	"./india.svg": [
		89325,
		[]
	],
	"./indonesia.svg": [
		98958,
		[]
	],
	"./iran.svg": [
		2820,
		[]
	],
	"./ireland.svg": [
		2661,
		[]
	],
	"./italy.svg": [
		25797,
		[]
	],
	"./japan.svg": [
		15424,
		[]
	],
	"./kenya.svg": [
		70648,
		[]
	],
	"./korea.svg": [
		96722,
		[]
	],
	"./latvia.svg": [
		54001,
		[]
	],
	"./lithuania.svg": [
		46081,
		[]
	],
	"./madagascar.svg": [
		46908,
		[]
	],
	"./mexico.svg": [
		23413,
		[]
	],
	"./mongolia.svg": [
		90778,
		[]
	],
	"./nepal.svg": [
		95762,
		[]
	],
	"./netherlands.svg": [
		5348,
		[]
	],
	"./norway.svg": [
		35118,
		[]
	],
	"./pakistan.svg": [
		40741,
		[]
	],
	"./philippines.svg": [
		86269,
		[]
	],
	"./poland.svg": [
		34944,
		[]
	],
	"./portugal.svg": [
		15962,
		[]
	],
	"./romania.svg": [
		31433,
		[]
	],
	"./russia.svg": [
		2287,
		[]
	],
	"./serbia.svg": [
		22606,
		[]
	],
	"./slovakia.svg": [
		12904,
		[]
	],
	"./slovenia.svg": [
		12797,
		[]
	],
	"./southAfrica.svg": [
		81597,
		[]
	],
	"./spain.svg": [
		41335,
		[]
	],
	"./sri-lanka.svg": [
		88166,
		[]
	],
	"./sweden.svg": [
		84176,
		[]
	],
	"./taiwan.svg": [
		87864,
		[
			7864
		]
	],
	"./timor-leste.svg": [
		98443,
		[]
	],
	"./tsonga.svg": [
		16368,
		[]
	],
	"./turkey.svg": [
		52978,
		[]
	],
	"./ukraine.svg": [
		15675,
		[]
	],
	"./united-arab-emirates.svg": [
		45807,
		[]
	],
	"./united-kingdom.svg": [
		87513,
		[]
	],
	"./united-states.svg": [
		16772,
		[]
	],
	"./vietnam.svg": [
		64616,
		[]
	],
	"./wales.svg": [
		45376,
		[]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(function() { return __webpack_require__(id); });
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 83008;
module.exports = webpackAsyncContext;